import { colors } from '../constants';

const STATUS_NORMALIZATION_MAP = {
  raised: 'open',
};

export const normalizeStatus = (status) => {
  if (status === undefined || status === null) return '';
  const value = status.toString().trim().toLowerCase();
  if (!value) return '';
  return STATUS_NORMALIZATION_MAP[value] || value;
};

export const formatStatusLabel = (status, { fallback = 'N/A', uppercase = false } = {}) => {
  const normalized = normalizeStatus(status);
  if (!normalized) return fallback;
  // Replace underscores with spaces and capitalize each word
  const formatted = normalized
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  return uppercase ? formatted.toUpperCase() : formatted;
};

export const getStatusColor = (status) => {
  const normalized = normalizeStatus(status);
  switch (normalized) {
    case 'open':
      return colors.info;
    case 'pending':
    case 'responded':
      return colors.primary;
    case 'escalated':
      return colors.warning;
    case 'closed':
    case 'resolved':
      return colors.success;
    case 'delegated':
      return colors.info;
    case 'reopened':
      return colors.secondary;
    case 'additional_clarification':
      return '#f59e0b'; // Orange/amber color for clarification needed
    default:
      return colors.textSecondary;
  }
};

export const shouldDisplayLegacyStatus = (status, statusLabel) => {
  if (!status) return false;
  const normalizedStatus = normalizeStatus(status);
  const normalizedLabel = normalizeStatus(statusLabel);
  return !normalizedLabel || normalizedStatus !== normalizedLabel;
};

